export const loginEn = {};

export const loginFr = {};
